import sound from "pixi-sound";
import scinarioBGM from "../assets/scinario_BGM.ogg";
import chatBGM from "../assets/chat.ogg";
import damageSE from "../assets/SE_damage.ogg";
import jumpSE from "../assets/SE_jump.ogg";
import powerupSE from "../assets/SE_powerup.ogg";

export class SoundManager {
  private scinario_bgm = sound.Sound.from({
    url: scinarioBGM,
    loop: true,
  });

  private chat_bgm = sound.Sound.from({
    url: chatBGM,
    loop: true,
  });
  private se_damage = sound.Sound.from(damageSE);
  private se_jump = sound.Sound.from(jumpSE);
  private se_powerup = sound.Sound.from(powerupSE);

  playScinarioBGM() {
    this.scinario_bgm.play();
  }

  stopSchinarioBGM() {
    this.scinario_bgm.stop();
  }

  playChatBGM() {
    this.chat_bgm.play();
  }

  stopChatBGM() {
    this.chat_bgm.stop();
  }

  playDamageSE() {
    this.se_damage.play();
  }

  playJumpSE() {
    this.se_jump.play();
  }

  playPowerupSE() {
    this.se_powerup.play();
  }
}
